import React from 'react'
import { Button, Tabs, Typography, theme } from 'antd'
import { PlusOutlined, CalendarOutlined } from '@ant-design/icons'
import { hexToRGBA } from '../../../lib/utils'

import SurgeryFilters from './Components/SurgeryFilters'
import SurgeryTable from './Components/SurgeryTable'
import ScheduleView from './Components/ScheduleView'
import ScheduleSurgeryModal from './Components/ScheduleSurgeryModal'
import SurgeryDetailsModal from './Components/SurgeryDetailsModal'

import useSurgeryData from './hooks/useSurgeryData'
import useModalState from './hooks/useModalState'

const { Title } = Typography
const { TabPane } = Tabs

const SurgeryList = () => {
  const { token } = theme.useToken()

  const {
    searchText,
    setSearchText,
    surgeryTypeFilter,
    setSurgeryTypeFilter,
    urgencyFilter,
    setUrgencyFilter,
    statusFilter,
    setStatusFilter,
    dateRange,
    setDateRange,
    filteredData,
    todaySurgeries,
    tomorrowSurgeries,
    futureSurgeries,
    surgeryTypes,
    surgeons,
    surgeryRooms
  } = useSurgeryData()

  const {
    isModalVisible,
    showDetailsFor,
    form,
    showModal,
    handleCancel,
    handleAdd,
    handleShowDetails,
    handleCloseDetails
  } = useModalState()

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px', position: 'relative' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)'
          }}
        >
          <CalendarOutlined style={{ marginRight: '8px', fontSize: '24px', color: token.colorPrimary }} />
          <Title level={4} style={{ margin: 0, color: token.colorPrimary }}>
            Surgery List
          </Title>
        </div>
        <div style={{ marginLeft: 'auto', marginRight: '20px' }}>
          <Button
            icon={<PlusOutlined style={{ color: token.colorSuccess }} />}
            onClick={showModal}
            style={{
              background: hexToRGBA(token.colorSuccess, 0.1),
              borderColor: token.colorSuccess,
              color: token.colorSuccess,
              fontWeight: 'bold'
            }}
          >
            Schedule Surgery
          </Button>
        </div>
      </div>

      {/* Filters and search */}
      <SurgeryFilters
        searchText={searchText}
        setSearchText={setSearchText}
        surgeryTypeFilter={surgeryTypeFilter}
        setSurgeryTypeFilter={setSurgeryTypeFilter}
        urgencyFilter={urgencyFilter}
        setUrgencyFilter={setUrgencyFilter}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        dateRange={dateRange}
        setDateRange={setDateRange}
        surgeryTypes={surgeryTypes}
      />

      <Tabs defaultActiveKey='table'>
        <TabPane tab='Table View' key='table'>
          <SurgeryTable data={filteredData} handleShowDetails={handleShowDetails} />
        </TabPane>

        <TabPane tab='Schedule View' key='schedule'>
          <ScheduleView
            todaySurgeries={todaySurgeries}
            tomorrowSurgeries={tomorrowSurgeries}
            futureSurgeries={futureSurgeries}
            handleShowDetails={handleShowDetails}
          />
        </TabPane>
      </Tabs>

      {/* Modals */}
      <ScheduleSurgeryModal
        isModalVisible={isModalVisible}
        handleCancel={handleCancel}
        handleAdd={handleAdd}
        form={form}
        surgeryTypes={surgeryTypes}
        surgeons={surgeons}
        surgeryRooms={surgeryRooms}
      />

      <SurgeryDetailsModal showDetailsFor={showDetailsFor} handleCloseDetails={handleCloseDetails} />
    </div>
  )
}

export default SurgeryList
